import React from "react";
import { useQuery } from "react-query";
import { GetCacheKey } from "../../services/common/utils";
import SwiperComponent from "../common/swipers";
import Loadingcomponent from "../loader/loadingcomponent";
import ErrorMessage from "../messaging/errormessage";

const SpecialOffers = ({ pmsitem }) => {
  const {
    data: { data } = {},
    isLoading,
    error,
    isFetching,
    isError,
    isLoadingError,
  } = useQuery(
    [
      GetCacheKey(pmsitem?.uniqueid),
      pmsitem?.method,
      JSON.parse(pmsitem?.sourceid),
      {},
    ],
    {
      retry: false,
      retryOnMount: false,
    }
  );

  if (isLoading || isFetching) {
    return <Loadingcomponent message={"Loading"} />;
  }

  if (error || isError || isLoadingError) {
    return <ErrorMessage message={"Invalid"} />;
  }
  return (
    <>
      {data?.response?.length > 0 && (
        <>
           <div class="mt-30 dls-sprint13-comp">
              <div class="d-flex align-items-center">
              <h3 className="section_title mb-0">
                {pmsitem?.elementmeta?.title}
              </h3>
              <img
                src={
                  pmsitem?.elementmeta?.icon === ""
                    ? ""
                    : pmsitem?.elementmeta?.icon
                }
                className="ms-2"
                width={20}
                alt=""
                title=""
                height={20}
              />
            </div>
            {/* <a className="hyperlink">
              {pmsitem?.elementmeta?.more_title}
              <img
                src={
                  process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'
                }
                alt=""
                title=""
              />
            </a> */}
          </div>
          <SwiperComponent
            type={1}
            data={data}
            psmItem={pmsitem}
          ></SwiperComponent>
        </>
      )}
    </>
  );
};
export default SpecialOffers;
